export default {
  pairs: [],
  showSearch: false,
  actives: [],
  activeSeries: [],
  notices: [],
  isLoading: false,
  supportedPairs: [],
  indexedProducts: {},
  proxyUrl: null,
  apiUrl: null,
  version: 'DEV',
  buildDate: 'now'
}
